import { postCurations } from '@musinsa/apis-curator';
import {
  lazyPipe,
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import { CreateCurationsServiceResponseSchema } from './create-curations.dto';
import type {
  CreateSnapCurationsServiceRequest,
  CreateSnapCurationsServiceResponse,
} from './create-snap-curations.dto';
import { CreateSnapCurationsServiceRequestSchema } from './create-snap-curations.dto';

export const createSnapCurationsService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(CreateSnapCurationsServiceRequestSchema),
    async (
      request: CreateSnapCurationsServiceRequest,
    ): Promise<CreateSnapCurationsServiceResponse> => {
      const response = await postCurations({
        title: request.title,
        description: request.description,
        type: request.curationType,
        goodsNoList: [],
        snapIdList: request.snapIdList,
      });

      if (response.meta?.result === 'FAIL') {
        throw new Error(response.meta?.message ?? '큐레이션 생성에 실패했습니다.');
      }

      return {
        success: true,
        curationId: response.data.curationId.toString(),
      };
    },
    validateServiceResponse(CreateCurationsServiceResponseSchema),
  ),
);
